import type { AchievementReportCreateBody } from '@mathflat/domain/Report'

import type { Student } from '@/dto'
import { fetchSSE } from '@/utils/axios/aiAxios.ts'

// 유형분석 보고서 AI 코멘트 요청. 보고서를 만들 때 고른 학년·교재·기출·추천 조건을 그대로 보낸다
export type AchievementReportAiCommentBody = Pick<
  AchievementReportCreateBody,
  'curriculumKey' | 'workbookIds' | 'schoolTestIds' | 'recommendFlag'
>

// 코멘트를 스트리밍(SSE)으로 받는 요청이라 domain 이음매(한 번에 resolve 하는 계약)로 보낼 수 없다
const aiApi = {
  // 유형분석 보고서 AI 코멘트 가져오기
  createAiComment(
    sessionId: string,
    studentId: Student['id'],
    data: AchievementReportAiCommentBody,
  ) {
    const body = JSON.stringify(data)

    return fetchSSE(`/ai/student-achievement/report-comment/${studentId}`, {
      params: { sessionId },
      body,
    })
  },
}

export default aiApi
